import React from 'react'
import BlurOnOutlinedIcon from '@material-ui/icons/BlurOnOutlined'
import CreateOutlinedIcon from '@material-ui/icons/CreateOutlined'
import BuildOutlinedIcon from '@material-ui/icons/BuildOutlined'
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined'
import DeveloperBoardOutlinedIcon from '@material-ui/icons/DeveloperBoardOutlined'
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined'
import SettingsEthernetOutlinedIcon from '@material-ui/icons/SettingsEthernetOutlined'
import AccountTreeIcon from '@material-ui/icons/AccountTree'
import ContactsOutlinedIcon from '@material-ui/icons/ContactsOutlined'
import GroupOutlinedIcon from '@material-ui/icons/GroupOutlined'
import AttachMoneyOutlinedIcon from '@material-ui/icons/AttachMoneyOutlined'
import PollOutlinedIcon from '@material-ui/icons/PollOutlined'
import AccountTreeOutlinedIcon from '@material-ui/icons/AccountTreeOutlined'
import AllInclusiveOutlinedIcon from '@material-ui/icons/AllInclusiveOutlined'
import DonutLargeIcon from '@material-ui/icons/DonutLarge'
import BugReportIcon from '@material-ui/icons/BugReport'
import { v4 as uuid } from 'uuid'

export const links = {
  portal: [
    {
      id: 1,
      name: 'Portal',
      url: '/portal',
      icon: <BlurOnOutlinedIcon />
    },
    {
      id: 2,
      name: 'Clients',
      url: '/clients',
      icon: <ContactsOutlinedIcon />
    },
    {
      id: 3,
      name: 'Projects',
      url: '/projects',
      icon: <AccountTreeIcon />
    },
    {
      id: 11,
      name: 'Engine',
      url: '/devops/api',
      icon: <DeveloperBoardOutlinedIcon />
    },
    {
      id: 12,
      name: 'Forms',
      url: '/devops/forms',
      icon: <CreateOutlinedIcon />
    },
    {
      id: 10,
      name: 'Report Issue',
      url: '/devops/issues',
      icon: <BugReportIcon />
    }
  ],

  admin: [
    {
      id: 3,
      name: 'Admin',
      url: '/admin',
      icon: <SettingsOutlinedIcon />
    },
    {
      id: 4,
      name: 'Finanace',
      url: '/admin/treasury',
      icon: <AttachMoneyOutlinedIcon />
    },
    {
      id: 5,
      name: 'Users',
      url: '/admin/users',
      icon: <GroupOutlinedIcon />
    },
    {
      id: 6,
      name: 'Clients',
      url: '/admin/clients',
      icon: <AllInclusiveOutlinedIcon />
    },
    {
      id: 7,
      name: 'Projects',
      url: '/admin/projects',
      icon: <AccountTreeOutlinedIcon />
    },
    {
      id: 8,
      name: 'Stats',
      url: '/admin/stats',
      icon: <PollOutlinedIcon />
    }
  ],
  subAdmin: [
    {
      id: 3,
      name: 'Admin',
      url: '/admin',
      icon: 'icon'
    }
  ],

  devops0: [
    {
      id: uuid(),
      name: 'Portal',
      url: '/portal/index',
      icon: <BlurOnOutlinedIcon />
    },
    {
      id: uuid(),
      name: 'Clients',
      url: '/clients/index',
      icon: <ContactsOutlinedIcon />
    },
    {
      id: uuid(),
      name: 'Projects',
      url: '/projects/index',
      icon: <AccountTreeIcon />
    },
    {
      id: uuid(),
      name: 'Admin',
      url: '/admin/index',
      icon: <SettingsOutlinedIcon />
    },
    {
      id: uuid(),
      name: 'Users',
      url: '/admin/users',
      icon: <AccountCircleOutlinedIcon />
    }
  ],
  devops1: [
    {
      id: uuid(),
      name: 'DevOps',
      url: '/devops/index',
      icon: <SettingsEthernetOutlinedIcon />
    },
    {
      id: uuid(),
      name: 'Engine',
      url: '/devops/api',
      icon: <DeveloperBoardOutlinedIcon />
    },
    {
      id: uuid(),
      name: 'Forms',
      url: '/devops/forms',
      icon: <CreateOutlinedIcon />
    },
    {
      id: uuid(),
      name: 'TestLab',
      url: '/devops/test-lab',
      icon: <BuildOutlinedIcon />
    },
    {
      id: uuid(),
      name: 'Processes',
      url: '/processes',
      icon: <DonutLargeIcon />
    }
  ]
}
